export const INDUSTRIES = [
  'Design & creative',
  'Architecture & engineering',
  'Construction & trades',
  'Consulting',
  'Legal & professional services',
  'Marketing & agencies',
  'Technology & software',
  'Media & events',
  'Other',
];

// Currencies must stay within the CURRENCIES list in utils/currency.js.
export const COUNTRIES = [
  { value: 'South Africa', currency: 'ZAR' },
  { value: 'United States', currency: 'USD' },
  { value: 'United Kingdom', currency: 'GBP' },
  { value: 'Ireland', currency: 'EUR' },
  { value: 'Germany', currency: 'EUR' },
  { value: 'Netherlands', currency: 'EUR' },
  { value: 'Australia', currency: 'AUD' },
  { value: 'Canada', currency: 'CAD' },
  { value: 'New Zealand', currency: 'NZD' },
  { value: 'Switzerland', currency: 'CHF' },
  { value: 'India', currency: 'INR' },
  { value: 'Singapore', currency: 'SGD' },
];

export const SIZE_BANDS = [
  { value: 'solo', label: 'Just me' },
  { value: '2-5', label: '2–5' },
  { value: '6-15', label: '6–15' },
  { value: '16-50', label: '16–50' },
  { value: '50+', label: '50+' },
];

// `path` is the sidebar route segment; modules without a page yet have none.
export const MODULES = [
  { key: 'leads', label: 'Leads & CRM', path: 'leads' },
  { key: 'projects', label: 'Projects & milestones', path: 'projects' },
  { key: 'schedule', label: 'Schedule', path: 'schedule' },
  { key: 'timesheets', label: 'Timesheets', path: 'timesheets' },
  { key: 'leave', label: 'Leave', path: 'leave-manager' },
  { key: 'tasks', label: 'Tasks', path: 'tasks' },
  { key: 'reports', label: 'Reports' },
];

export const INVITE_ROLES = [
  { value: 'member', label: 'Team member' },
  { value: 'manager', label: 'Manager' },
  { value: 'admin', label: 'Admin' },
];

export const EMPLOYMENT_TYPES = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'contractor', label: 'Contractor' },
];

// Order matches the checklist the backend returns.
export const CHECKLIST_ITEMS = [
  { key: 'client', title: 'Add your first client', subtitle: 'Directory · companies and contacts', path: '/dashboard/directory' },
  { key: 'project', title: 'Create a project with milestones', subtitle: 'Projects · budget, team and job lists', path: '/dashboard/projects' },
  { key: 'booking', title: 'Book your team for this week', subtitle: 'Schedule · drag across days to book', path: '/dashboard/schedule' },
  { key: 'invites', title: 'Check your invites', subtitle: 'People', path: '/dashboard/people' },
];

export const PENDING_VERIFICATION_KEY = 'nodel_pending_verification';

export const passwordStrength = (pw) =>
  [pw.length >= 8, /\d/.test(pw), /[A-Z]/.test(pw), /[^A-Za-z0-9]/.test(pw) || pw.length >= 12].filter(Boolean).length;

export const isValidPassword = (pw) => pw.length >= 8 && /\d/.test(pw) && /[A-Z]/.test(pw);

// Mirrors the backend's usage pricing: every person is a user, contractors and added resources are billed as resources, with a monthly minimum.
export function monthlyCost({ permanent, contractors, resources }, pricing) {
  const users = permanent + contractors;
  const calculated = users * pricing.per_user + (contractors + resources) * pricing.per_resource;
  return Math.max(calculated, pricing.minimum);
}

export function parseEmails(text) {
  return [...new Set(text.split(/[\s,;]+/).map((e) => e.trim().toLowerCase()).filter((e) => /^\S+@\S+\.\S+$/.test(e)))];
}
